module.exports = __webpack_public_path__ + "img/Connexion@2x-100.b7b070b7.jpg";